export default __webpack_public_path__ + "static/avatar-kayi-common-5-721f2c5c8978944ac0bd1ed53eab8886.png";